module.exports = __webpack_public_path__ + "jm.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/jm.svg
// module id = 625
// module chunks = 0